import IntlMessageFormat from "intl-messageformat";

export const getUserFullName = ({
  firstName,
  lastName,
}: {
  firstName?: string;
  lastName?: string;
}) => {
  if (!firstName && !lastName) {
    return "";
  }
  if (!lastName) {
    return firstName;
  }
  return `${firstName} ${lastName}`;
};

export const formatTimePastSince = (date: Date) => {
  const now = new Date();
  const diff = now.getTime() - date.getTime();
  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  if (days > 0) {
    return {
      value: days,
      unit: "days",
    };
  } else if (hours > 0) {
    return {
      value: hours,
      unit: "hours",
    };
  } else if (minutes > 0) {
    return {
      value: minutes,
      unit: "minutes",
    };
  }
  return {
    value: 0,
    unit: "minutes",
  };
};

export const hasLimitedScreenHeight = () => {
  return window.innerHeight < 940;
};

export const formatIcuMessage = (
  message: string,
  value: number,
  locale: string = "en",
) => {
  const msg = new IntlMessageFormat(message, locale);
  return msg.format({ unit: value });
};

export const isServerSideRendering = () => {
  return typeof window === "undefined";
};
